import { notification } from "antd";
import queryStrings from "query-string";
import jwtDecode from "jwt-decode";
import httpService from "./httpService";
import config from "../config.json";

const configCASHeader = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
};

export async function sendLoginOtp(mobile) {
  httpService.setAccessHeader(null);
  const formData = {
    mn: mobile,
    sern: config.SERVICE_NAME,
    serv: config.SERVICE_VERSION,
    nt: "sms"
  };

  try {
    const response = await httpService.post(
      process.env.REACT_APP_CAS_URL + config.CAS_OTP_PATH,
      queryStrings.stringify(formData),
      configCASHeader
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function sendLoginOtpCall(mobile) {
  httpService.setAccessHeader(null);
  const formData = {
    mn: mobile,
    sern: config.SERVICE_NAME,
    serv: config.SERVICE_VERSION,
    nt: "ivr"
  };

  try {
    const response = await httpService.post(
      process.env.REACT_APP_CAS_URL + config.CAS_OTP_PATH,
      queryStrings.stringify(formData),
      configCASHeader
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getEmployeeDetails(empCode) {
  try {
    const baseUrl = httpService.getBaseUrl();
    const url = baseUrl + "/user/validate-employee-details?empCode=" + empCode;
    const { data } = await httpService.get(url);
    return data.dt;
  } catch (error) {
    throw error;
  }
}

export async function validateOtpAuth(authToken) {
  httpService.setAccessHeader(getJwt());
  const formData = {
    grant_type: "otp",
    jwt: authToken,
    sern: config.SERVICE_NAME,
    serv: config.SERVICE_VERSION
  };

  try {
    const response = await httpService.post(
      process.env.REACT_APP_CAS_URL + config.CAS_OTP_AUTH_VALIDATE_PATH,
      queryStrings.stringify(formData),
      configCASHeader
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function login(mobile, otp, requestId) {
  const formData = {
    mn: mobile,
    sern: config.SERVICE_NAME,
    serv: config.SERVICE_VERSION,
    rid: requestId,
    otp: otp
  };

  try {
    const { data } = await httpService.post(
      process.env.REACT_APP_CAS_URL + config.CAS_OTP_AUTH_PATH,
      queryStrings.stringify(formData),
      configCASHeader
    );
    localStorage.setItem(config.JWT_TOKEN, data.access_token);

    let baseURL = "http://localhost:8080/api";
    if (process.env.REACT_APP_API_ENV_URL !== "localhost") {
      const service = data.ser[0];
      baseURL = "https://" + service.si;
      baseURL = baseURL + "." + process.env.REACT_APP_API_ENV_URL;
    }
    localStorage.setItem(config.BASE_URL, baseURL);
    httpService.setAccessHeader(getJwt());
  } catch (err) {
    notification.warning({
      message: "Login Error",
      description: err.response.data.message
    });
  }

  if ((mobile && otp, requestId)) {
    return true;
  }
  return false;
}

export async function currentAccount() {
  try {
    const token = getJwt();

    // const tokenData = jwtDecode(
    //   "eyJhbGciOiJIUzI1NiJ9.eyJtbiI6Ijc3MjgwOTU2MzQiLCJ1aWQiOiI0MTMiLCJyb2xlIjoiUk9MRV9TQUxFU19BRE1JTiIsInVuYW1lIjoiQmhhdmVzaCBLYXRhcmlhIiwia2lkIjoiMTc5MyIsInJvbGVzIjpbIlJPTEVfU0FMRVNfQURNSU4iLCJST0xFX01LVFBfQURNSU4iXSwiY2xpZCI6InNhbGVzLWNoYW5uZWwiLCJjbHYiOiJ2MSIsImV4cCI6MTU3Mjg5MjE5OSwiZ3QiOiJvdHAiLCJ2dCI6MSwianRpIjoiMTc3MDgzODQifQ.CDO5MinrL6EeptWyTTFD8Jm__MnvupIfOJctsvrKKW8"
    // );
    //const { data } = await validateOtpAuth(token);

    const tokenData = jwtDecode(token);

    console.log("FACILITY", JSON.parse(tokenData.cp.facility));
    // if (tokenData && data.s) {
    if (tokenData) {
      httpService.setAccessHeader(token);
      return {
        id: tokenData.uid,
        name: tokenData.uname,
        email: tokenData.email,
        mobile: tokenData.mn,
        avatar: null,
        roles: tokenData.roles,
        facility: JSON.parse(tokenData.cp.facility),
        authorized: true
      };
    }
  } catch (ex) {
    console.log(ex);
  }
  return null;
}

export function currentUserRoles() {
  try {
    const token = localStorage.getItem(config.JWT_TOKEN);
    const { roles } = jwtDecode(token);
    return roles;
  } catch (ex) {
    return null;
  }
}

export function currentUserFacility() {
  try {
    const token = localStorage.getItem(config.JWT_TOKEN);
    const { faicility } = jwtDecode(token);
    return JSON.parse(faicility);
  } catch (ex) {
    return null;
  }
}

export async function logout() {
  localStorage.removeItem(config.JWT_TOKEN);
  localStorage.removeItem(config.BASE_URL);
  return true;
}

export function getJwt() {
  return localStorage.getItem(config.JWT_TOKEN);
}

export default {
  sendLoginOtp,
  sendLoginOtpCall,
  login,
  currentAccount,
  currentUserRoles,
  currentUserFacility,
  logout,
  getEmployeeDetails,
  getJwt
};
